import { apiClient } from './apiClient';

/**
 * Appointment service for API operations
 */
export class AppointmentService {
    constructor() {
        this.BASE_URL = '/appointment';
    }

    async createAppointment(appointmentData) {
        try {
            const response = await apiClient.post(this.BASE_URL, appointmentData);
            return response;
        } catch (error) {
            console.error('Error creating appointment:', error);
            throw error;
        }
    }

    async getAppointmentById(appointmentId) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/${appointmentId}`);
            return response;
        } catch (error) {
            console.error('Error fetching appointment:', error);
            throw error;
        }
    }

    async updateSelectedAppointmentSlot(appointmentId, slotData) {
        try {
            const response = await apiClient.patch(`${this.BASE_URL}/${appointmentId}/select-slot`, slotData);
            return response;
        } catch (error) {
            console.error('Error selecting appointment slot:', error);
            throw error;
        }
    }
}

export const appointmentService = new AppointmentService();
